<div>
  @if (config$ | async; as config) {
    <!-- Same box as the header on bildigsnetz.ch (section-container, h-20),
         so logo and buttons stay in place when a visitor moves between the
         website and the app. -->
    <mat-toolbar class="!bg-light-navy !text-light-on-navy !h-20 w-full !p-0">
      <div
        class="flex items-center gap-1 w-full h-20 max-w-[1512px] mx-auto px-4 sm:px-8 lg:px-site-gutter-lg xl:px-site-gutter-xl">
        <a [href]="baseUrl" class="flex shrink-0 flex-col items-start gap-1">
          <img
            alt="Bildigsnetz"
            width="129"
            height="29"
            class="w-[129px] h-[29px] object-contain"
            src="assets/brand/logo-white.svg" />
          <span class="flex items-center gap-1 pl-9" aria-hidden="true">
            <span class="size-[5px] rounded-full bg-light-on-navy"></span>
            <img
              alt=""
              class="h-2.5 w-auto brightness-0 invert"
              src="assets/brand/bildungsstellen.svg" />
          </span>
        </a>
        <app-navigation
          class="contents"
          [isOpen]="mobileMenuIsOpen"
          (navigate)="closeMobileMenu()" />
        <nav class="hidden xl:flex items-center gap-[10px] shrink-0">
          @if (config.showLogin || config.showBoth) {
            <app-pressable
              routerLink="/login"
              variant="outline"
              [label]="'publicNav.login' | translate" />
          }
          @if (!config.showLogin || config.showBoth) {
            <app-pressable
              routerLink="/signup"
              variant="brand"
              [label]="'publicNav.signup' | translate" />
          }
          <app-dropdown />
        </nav>
        <app-language-switch class="ml-auto shrink-0 xl:ml-0" />
        <app-burger
          class="xl:hidden"
          [isOpen]="mobileMenuIsOpen"
          (toggleMenu)="toggleMobileMenu($event)" />
      </div>
    </mat-toolbar>
  }
</div>
